module.exports = __webpack_public_path__ + "img/applet.4435768c.png";